// src/components/ui/badge.js
import React from 'react';

export function Badge({ children, className = '', ...props }) {
  return (
    <div 
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-gray-950 focus:ring-offset-2 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}